/**
 * Koduje "&" na "%26" w przekazanym ciągu.
 *
 * @param {string} str - string do zakodowania
 * @return {string}
 */
const codeAmpersand = str => str.replace(/&/g, '%26');

export default codeAmpersand;
